import script from "./Pelanggan.vue?vue&type=script&setup=true&lang=js"
export * from "./Pelanggan.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__